const subscribeMessage = 'This feature is exclusive for PRO users';
const subscribeButton = 'Subscribe';

export { subscribeMessage, subscribeButton };
